import { createElement, useCallback, useState } from 'react';
import styled from 'styled-components';

import { Dialog } from '@sorare/core/src/components/dialog';
import { Stepper } from '@sorare/core/src/components/onboarding/Dialog/Stepper';
import { laptopAndAbove } from '@sorare/core/src/style/mediaQuery';

import { LevelUp } from './LevelUp';
import { SelectYourCard } from './SelectYourCard';
import { UnlockPerks } from './UnlockPerks';

const StepperWrapper = styled.div`
  width: 120px;
  margin: auto;
  margin-top: var(--double-unit);
`;

const StyledDialog = styled(Dialog)`
  position: relative;

  & > div {
    display: flex;
    flex-direction: column;

    @media ${laptopAndAbove} {
      background: rgba(16, 16, 16, 0.54);
      backdrop-filter: blur(16px);
      min-height: min(calc(100vh - var(--unit) * 8), 800px);
    }
  }
`;

type Props = {
  isOpen: boolean;
  setIsOpen: (isOpen: boolean) => void;
};

type StepComponent = React.ComponentType<{
  onClose: () => void;
  nextStep: () => void;
  prevStep: () => void;
  selectedFavoriteTeam?: string;
  setSelectedFavoriteTeam: (teamId: string) => void;
}>;

export const SealingOnboardingFlow = ({ isOpen, setIsOpen }: Props) => {
  const [step, setStep] = useState(0);
  const [selectedFavoriteTeam, setSelectedFavoriteTeam] = useState<
    string | undefined
  >();

  const steps: StepComponent[] = [SelectYourCard, LevelUp, UnlockPerks];

  const onClose = useCallback(() => {
    setIsOpen(false);
  }, [setIsOpen]);

  const nextStep = useCallback(() => {
    setStep(step + 1);
  }, [step]);

  const prevStep = useCallback(() => {
    setStep(step - 1);
  }, [step]);

  return (
    <StyledDialog
      hideHeader
      fullWidth
      disableBackdropClick
      open={isOpen}
      maxWidth="xs"
      onClose={() => setIsOpen(false)}
    >
      <StepperWrapper>
        <Stepper step={step} length={steps.length} setStep={n => setStep(n)} />
      </StepperWrapper>
      {createElement(steps[step], {
        onClose,
        nextStep,
        prevStep,
        selectedFavoriteTeam,
        setSelectedFavoriteTeam,
      })}
    </StyledDialog>
  );
};
